<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form">
        <v-text-field
          type="text"
          :readonly="isReadMode"
          v-model="folder.name"
          :label="$t('folders.name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.required, backEndValidation('name')]
          "
        ></v-text-field>
        <v-textarea
          :readonly="isReadMode"
          v-model="folder.notices"
          :label="$t('folders.notices')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('notices')]"
        ></v-textarea>
      </v-form>
    </v-col>
    <v-col>
      <v-btn
        color="primary"
        v-on:click="updateFolder()"
        :loading="loading"
        v-if="!isReadMode"
      >
        <v-icon left>mdi-pencil</v-icon> {{ $t("folders.update") }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { rules } from "./../mixins/rules";
export default {
  name: "EditFolder",
  mixins: [rules],
  data: () => ({
    loading: false
  }),
  computed: {
    folder: {
      get() {
        return this.$store.getters["folderStore/getItem"];
      }
    },
    isReadMode() {
      return (
        !!this.folder &&
        !this.folder._permissions.find(i => i === "folder.update")
      );
    },
    resourceLoading() {
      return !this.folder.id;
    }
  },
  props: ["id"],
  methods: {
    updateFolder() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("folderStore/update", {
            item: {
              id: this.folder.id,
              name: this.folder.name,
              notices: this.folder.notices
            },
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>

<style scoped></style>
